export const bankAccount = {
  accountNumber: "742-KAP-2024-0391",
  bankName: "가상 기업은행",
  balance: 127500,
  currency: "만원 (KRW)",
};

export const transactions = [
  { id: "tx1", date: "2026.03.27", type: "입금", category: "계약금", description: "루나&스타즈 EP 제작 계약금", amount: 12000, balance: 127500 },
  { id: "tx2", date: "2026.03.26", type: "출금", category: "인건비", description: "3월 전체 직원 급여 지급", amount: -8500, balance: 115500 },
  { id: "tx3", date: "2026.03.25", type: "출금", category: "외주비", description: "YoonArt 앨범커버 디자인 대금", amount: -2200, balance: 124000 },
  { id: "tx4", date: "2026.03.24", type: "입금", category: "음원정산", description: "가상 멜론 2월분 음원 수익 정산", amount: 3800, balance: 126200 },
  { id: "tx5", date: "2026.03.23", type: "출금", category: "마케팅비", description: "SNS 광고 집행 (인스타그램)", amount: -1500, balance: 122400 },
  { id: "tx6", date: "2026.03.22", type: "입금", category: "공연수익", description: "K-POP 페스티벌 출연료", amount: 25000, balance: 123900 },
  { id: "tx7", date: "2026.03.21", type: "출금", category: "임대료", description: "사무실 임대료 + 녹음스튜디오 대관", amount: -4800, balance: 98900 },
  { id: "tx8", date: "2026.03.20", type: "출금", category: "장비비", description: "조명/음향 장비 렌탈", amount: -1800, balance: 103700 },
  { id: "tx9", date: "2026.03.19", type: "입금", category: "협찬금", description: "서울전자 MV 협찬 계약금", amount: 8000, balance: 105500 },
  { id: "tx10", date: "2026.03.18", type: "출금", category: "세금", description: "부가가치세 1기 예정 납부", amount: -3200, balance: 97500 },
];

export const budgetItems = [
  { id: "b1", dept: "A&R", category: "데모곡 수급", allocated: 8000, spent: 3200, remaining: 4800, status: "정상" },
  { id: "b2", dept: "제작", category: "뮤직비디오 제작", allocated: 50000, spent: 32000, remaining: 18000, status: "경고" },
  { id: "b3", dept: "마케팅", category: "SNS 광고", allocated: 6000, spent: 5800, remaining: 200, status: "위험" },
  { id: "b4", dept: "법무", category: "법률 자문비", allocated: 3000, spent: 800, remaining: 2200, status: "정상" },
  { id: "b5", dept: "인사", category: "직원 급여", allocated: 30000, spent: 17000, remaining: 13000, status: "정상" },
  { id: "b6", dept: "시설", category: "사무실·스튜디오", allocated: 12000, spent: 9600, remaining: 2400, status: "경고" },
  { id: "b7", dept: "마케팅", category: "보도자료·PR", allocated: 4000, spent: 1200, remaining: 2800, status: "정상" },
  { id: "b8", dept: "A&R", category: "오디션·발굴", allocated: 5000, spent: 1000, remaining: 4000, status: "정상" },
];

export const taxEvents = [
  {
    id: "tax1",
    title: "3월 원천세 신고·납부",
    dueDate: "2026.04.10",
    amount: 1250,
    status: "대기중",
    description: "직원 급여에서 원천징수한 세금을 국세청에 신고·납부해야 합니다.",
    penalty: "기한 초과 시 가산세 3% 부과 + 신용도 -5pt",
  },
  {
    id: "tax2",
    title: "부가가치세 1기 확정신고",
    dueDate: "2026.04.25",
    amount: 4800,
    status: "대기중",
    description: "1월~3월 매출에 대한 부가가치세를 신고·납부해야 합니다.",
    penalty: "기한 초과 시 무신고가산세 20% + 신용도 -10pt",
  },
  {
    id: "tax3",
    title: "4대보험 3월분 납부",
    dueDate: "2026.04.10",
    amount: 2100,
    status: "납부완료",
    description: "국민연금, 건강보험, 고용보험, 산재보험 사용자 부담분 납부",
    penalty: "",
  },
  {
    id: "tax4",
    title: "사무실 임대료 4월분",
    dueDate: "2026.04.01",
    amount: 3500,
    status: "납부완료",
    description: "사무실 월세 및 관리비 납부",
    penalty: "",
  },
];

export const monthlySummary = [
  { month: "10월", income: 42000, expense: 35000, profit: 7000 },
  { month: "11월", income: 55000, expense: 41000, profit: 14000 },
  { month: "12월", income: 71000, expense: 52000, profit: 19000 },
  { month: "1월", income: 38000, expense: 45000, profit: -7000 },
  { month: "2월", income: 62000, expense: 48000, profit: 14000 },
  { month: "3월", income: 81000, expense: 55000, profit: 26000 },
];
